export const PHONE_ISO_TO_NUMERIC: Record<string, number> = {
  CL: 56,
  PE: 51,
  CO: 57,
  MX: 52,
  US: 1,
  USA: 1,
  AR: 54,
  EC: 593,
  BR: 55,
  ES: 34,
};

export const PHONE_NUMERIC_TO_ISO: Record<number, string> = {
  56: 'CL',
  51: 'PE',
  57: 'CO',
  52: 'MX',
  1: 'US',
  54: 'AR',
  593: 'EC',
  55: 'BR',
  34: 'ES',
};

export const isoToNumericPhone = (iso?: string | null): number | undefined => {
  if (!iso) return undefined;
  return PHONE_ISO_TO_NUMERIC[iso.toUpperCase()];
};

export const numericToIsoPhone = (numeric?: number): string | undefined => {
  if (numeric === undefined || numeric === null) return undefined;
  return PHONE_NUMERIC_TO_ISO[numeric];
};

/**
 * Convierte el `phoneCountryCode` del backend a su forma numérica de dial code.
 * Acepta tres formatos posibles: ISO alpha-2 ("CL"), dial code con + ("+56"),
 * o dial code sin + ("56").
 */
export const parsePhoneCountryCode = (
  raw?: string | null
): number | undefined => {
  if (!raw) return undefined;
  const trimmed = String(raw).trim();
  if (!trimmed) return undefined;
  // "+56" o "+1"
  if (trimmed.startsWith('+')) {
    const digits = trimmed.slice(1).replace(/\D/g, '');
    const num = parseInt(digits, 10);
    return isNaN(num) ? undefined : num;
  }
  // "56", "1", etc.
  if (/^\d+$/.test(trimmed)) {
    return parseInt(trimmed, 10);
  }
  // "CL", "PE", ...
  return PHONE_ISO_TO_NUMERIC[trimmed.toUpperCase()];
};

/**
 * Devuelve el dial code con prefijo "+" a partir del numérico (ej: 56 → "+56").
 * Se usa al guardar para el backend, que espera `phoneCountryCode` en formato
 * "+XX" según el contrato real observado en runtime.
 */
export const numericToDialCode = (numeric?: number): string | undefined => {
  if (numeric === undefined || numeric === null) return undefined;
  return `+${numeric}`;
};

export const OTHER_UNIVERSITY_VALUE = -1;

/**
 * The administrative division wording changes per country (Chile uses
 * "Región"/"Comuna", Peru "Departamento"/"Distrito", ...). These helpers return
 * only the translation key suffix, so each consumer can prefix it with its own
 * i18n namespace while sharing the same country mapping.
 */
export const getRegionLabelKey = (countryCode: string): string => {
  switch ((countryCode || '').toUpperCase()) {
    case 'CL':
      return 'region_cl';
    case 'PE':
      return 'region_pe';
    case 'CO':
      return 'region_co';
    default:
      return 'region_default';
  }
};

export const getCityLabelKey = (countryCode: string): string => {
  switch ((countryCode || '').toUpperCase()) {
    case 'CL':
      return 'city_cl';
    case 'PE':
      return 'city_pe';
    case 'CO':
      return 'city_co';
    default:
      return 'city_default';
  }
};
